import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const editContact = createAsyncThunk(
  "contact/editContact",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/profiles/contact-info/${payload?.id}`,
        payload,
        {
          meta: { base: "contact_api" },
        }
      );
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error editing contact"
      );
    }
  }
);

export const editDriverLicence = createAsyncThunk(
  "contact/editDriverLicence",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/profiles/additional-info/${payload?.contact_ID}`,
        payload,
        {
          meta: { base: "contact_api" },
        }
      );
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error editing contact"
      );
    }
  }
);

export const editTaxExempt = createAsyncThunk(
  "contact/editTaxExempt",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/profiles/billing-info/${payload?.contact_ID}`,
        payload,
        {
          meta: { base: "contact_api" },
        }
      );
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error editing contact"
      );
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    editContactRes: {},
    editContactloading: false,
    editContactError: null,
    editTaxloading: false,
    editDriverloading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
     .addCase(editContact.pending, (state) => {
            state.editContactloading = true;
          })
          .addCase(editContact.fulfilled, (state, action) => {
            state.editContactloading = false;
            state.editContactRes = action.payload;
          })
          .addCase(editContact.rejected, (state, action) => {
            state.editContactError = action.payload;
            state.editContactloading = false;
          })
      .addCase(editTaxExempt.pending, (state) => {
        state.editTaxloading = true;
      })
      .addCase(editTaxExempt.fulfilled, (state, action) => {
        state.editTaxloading = false;
      })
      .addCase(editTaxExempt.rejected, (state, action) => {
        state.editTaxloading = false;
      })
      .addCase(editDriverLicence.pending, (state) => {
        state.editDriverloading = true;
      })
      .addCase(editDriverLicence.fulfilled, (state, action) => {
        state.editDriverloading = false;
      })
      .addCase(editDriverLicence.rejected, (state, action) => {
        state.editDriverloading = false;
      });
  },
});

export default contactSlice.reducer;
